import { createAction } from 'redux-act'
import {
    SET_COUNT,
    INCREMENT_COUNT,
    DECREMENT_COUNT,
    INIT_GUEST_FAVORITES,
    ADD_GUEST_FAVORITE,
    REMOVE_GUEST_FAVORITE,
} from './action-types'

export const setCountTransport = createAction<number | undefined>(SET_COUNT)
export const incrementCountTransport = createAction(INCREMENT_COUNT)
export const decrementCountTransport = createAction(DECREMENT_COUNT)

// Guest favorite listings actions (for logged-out users)
export const initGuestFavorites = createAction<string[]>(INIT_GUEST_FAVORITES)
export const addGuestFavorite = createAction<string>(ADD_GUEST_FAVORITE)
export const removeGuestFavorite = createAction<string>(REMOVE_GUEST_FAVORITE)
